import React from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import BusDetail from '../components/BusDetail';
import '../i18n';

const BusTripDetail = observer(props => {
  const { t } = useTranslation();

  //Refactor
  const _headerCol = [
    t('busTripDetail.columnHeadings.1'),
    t('busTripDetail.columnHeadings.2'),
    t('busTripDetail.columnHeadings.3'),
    t('busTripDetail.columnHeadings.4')
  ];

  return (
    <BusDetail
      headerCol={_headerCol}
      params={props.params}
    />
  );
});

export default BusTripDetail;
